import { IntegrationSavedSuccessWebComponent } from './component/IntegrationSavedSuccessWebComponent';
import { WEB_COMPONENT_INTEGRATION_SAVED_SUCCESS } from '../../webcomponents.constants';

export { IntegrationSavedSuccessWebComponent };

window.customElements.define(WEB_COMPONENT_INTEGRATION_SAVED_SUCCESS, IntegrationSavedSuccessWebComponent);
